import React, { useEffect, useState } from "react";
import {
  fetchChavePix,
  excluirChavePix,
  adicionarChavePix
} from "../../../integration/pix/fetchChavePix";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ChavePixTabela = () => {
  const [chavesPix, setChavesPix] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const carregarChaves = async () => {
    setCarregando(true);
    try {
      const resposta = await fetchChavePix();
      setChavesPix(resposta.data);
    } catch (erro) {
      setChavesPix([]);
      const msgErro =
        erro.response?.data?.error ||
        erro?.error ||
        erro.message ||
        "Erro de servidor";
      toast.error(msgErro);
    } finally {
      setCarregando(false);
    }
  };

  const handleExcluir = async (chaveId) => {
    if (!window.confirm("Tem certeza que deseja excluir esta chave Pix?"))
      return;

    try {
      await excluirChavePix(chaveId);
      toast.success("Chave Pix excluída com sucesso.");
      carregarChaves();
    } catch (erro) {
      const msgErro =
        erro.response?.data?.error ||
        erro?.error ||
        erro.message ||
        "Erro de servidor";
      toast.error(msgErro);
    }
  };

  useEffect(() => {
    carregarChaves();
  }, []);

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [novaChave, setNovaChave] = useState("");
  const [novoTipo, setNovoTipo] = useState("");
  const [documentoTitular, setDocumentoTitular] = useState("");
  const [nomeTitular, setNomeTitular] = useState("");

  const limparCamposFormulario = () => {
    setNovaChave("");
    setNovoTipo("");
    setDocumentoTitular("");
    setNomeTitular("");
  };

  const handleSalvarChave = () => {
    if (!novaChave || !novoTipo || !documentoTitular || !nomeTitular) {
      toast.warn("Preencha todos os campos.");
      return;
    }

    salvarChavePix(novoTipo, novaChave, documentoTitular, nomeTitular);
  };

  const salvarChavePix = async (tipo, chave, documento, nomeTitular) => {
    setCarregando(true);
    try {
      await adicionarChavePix({ tipo, chave, documento, nomeTitular });
      toast.success("Chave Pix salva no servidor.");
      limparCamposFormulario();
      setMostrarFormulario(false);
      carregarChaves();
    } catch (erro) {
      const msgErro =
        erro.response?.data?.error ||
        erro?.error ||
        erro.message ||
        "Erro de servidor";
      toast.error(msgErro);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="w-full max-w-6xl mx-auto p-6 bg-[#fcfcfd] rounded-2xl">
      <ToastContainer position="top-right" autoClose={3000} />

      <button
        onClick={() => setMostrarFormulario(!mostrarFormulario)}
        className="inline-flex items-center gap-2 px-5 mb-5 py-2 bg-[#f5f4f1] text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition"
      >
        + Adicionar Chave
      </button>

      {mostrarFormulario && (
        <div className="mt-4 mb-6 p-6 bg-white rounded-xl border border-gray-200 shadow-sm space-y-4">
          <h3 className="text-xl font-light text-[#0c0c0c]">
            Cadastrar nova chave Pix
          </h3>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Tipo da chave
            </label>
            <select
              value={novoTipo}
              onChange={(e) => setNovoTipo(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
            >
              <option value="">Selecione...</option>
              <option value="cnpj">CNPJ</option>
              <option value="cpf">CPF</option>
              <option value="email">Email</option>
              <option value="telefone">Telefone</option>
              <option value="aleatoria">Chave Aleatória</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Chave
            </label>
            <input
              type="text"
              value={novaChave}
              onChange={(e) => setNovaChave(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder="Digite a chave Pix"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Documento do Titular (CPF ou CNPJ)
            </label>
            <input
              type="text"
              value={documentoTitular}
              onChange={(e) => setDocumentoTitular(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder="Digite o CPF ou CNPJ"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Nome completo do Titular
            </label>
            <input
              type="text"
              value={nomeTitular}
              onChange={(e) => setNomeTitular(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
              placeholder="Digite o nome do titular"
            />
          </div>

          <div className="text-right">
            <button
              onClick={handleSalvarChave}
              className="inline-flex items-center gap-2 px-5 py-2 bg-[#f5f4f1] text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition"
            >
              Salvar Chave
            </button>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-light text-[#332727]">Chaves Pix</h2>
        <span className="text-gray-500 text-sm">
          Total: <strong>{chavesPix.length}</strong> registros
        </span>
      </div>

      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-[#f5f4f1] text-gray-700 font-semibold">
            <tr>
              <th className="px-4 py-3 text-left">ID</th>
              <th className="px-4 py-3 text-left">Tipo</th>
              <th className="px-4 py-3 text-left">Chave</th>
              <th className="px-4 py-3 text-left">Titular</th>
              <th className="px-4 py-3 text-left">Documento</th>
              <th className="px-4 py-3 text-left">Data</th>
              <th className="px-4 py-3 text-left">Ação</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {carregando ? (
              <tr>
                <td colSpan={7} className="text-center py-4 text-gray-500">
                  Carregando...
                </td>
              </tr>
            ) : chavesPix.length > 0 ? (
              chavesPix.map((item, index) => (
                <tr
                  key={item.key + index}
                  className="hover:bg-gray-50 transition"
                >
                  <td className="px-4 py-3 capitalize">
                    {item.id || index + 1}
                  </td>
                  <td className="px-4 py-3">{item.type.toUpperCase()}</td>
                  <td className="px-4 py-3">{item.key}</td>
                  <td className="px-4 py-3">{item.titlename || "-"}</td>
                  <td className="px-4 py-3">{item.document || "-"}</td>
                  <td className="px-4 py-3">{item.date}</td>
                  <td className="px-4 py-3">
                    <button
                      onClick={() => handleExcluir(item.id || item.key)}
                      className="text-red-600 hover:underline text-sm"
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-4 text-gray-500">
                  Nenhuma chave Pix encontrada.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChavePixTabela;
